import PlantingAreaPopover from './PlantingAreaPopover';

export default PlantingAreaPopover;
